module.exports = __webpack_public_path__ + "img/7407627.png";